import { Skeleton } from '@/shared/components/ui';
import { PageContainer } from '@/shared/components/layout';
import { useT } from '@/shared/i18n/useT';

/** Esqueleto mientras llega el chunk de la pantalla: tiene la forma de una página (cabecera + tarjetas). */
export function RouteFallback() {
  const { t } = useT();
  return (
    <PageContainer>
      <div role="status" aria-label={t('states.loadingPage')} className="flex flex-col gap-6">
        <Skeleton className="h-9 w-2/3 max-w-sm" />
        <Skeleton className="h-40 w-full rounded-lg" />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <Skeleton className="h-36 rounded-lg" />
          <Skeleton className="h-36 rounded-lg" />
          <Skeleton className="hidden h-36 rounded-lg lg:block" />
        </div>
      </div>
    </PageContainer>
  );
}
